import { render, staticRenderFns } from "./ProductReturnModal.vue?vue&type=template&id=5bf450c2"
import script from "./ProductReturnModal.vue?vue&type=script&lang=js"
export * from "./ProductReturnModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports